var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 30h24v-2H4zM21.636 5.121a1.001 1.001 0 011.415 0l2.828 2.828c.389.39.389 1.025 0 1.415l-1.414 1.414-4.243-4.243 1.414-1.414zM18.808 7.95l4.243 4.243-10.42 10.42-5.833 1.59 1.59-5.834L18.809 7.95zM5.373 26.627c.088 0 .176-.012.263-.035l7.778-2.12a.968.968 0 00.432-.27l.012.011 13.435-13.435a3.003 3.003 0 000-4.243l-2.828-2.828a3.002 3.002 0 00-4.243 0L6.787 17.142l.01.011a.972.972 0 00-.268.433l-2.121 7.778a1 1 0 00.965 1.263z"
  })))));
}

export default SvgIconEdit;